// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2hGAO","calendarButtons":"ClockData_calendarButtons__110Md"};